
export const heroData = {
  badge: "AI-Native Recruitment Platform",
  title: "Transform Hiring with Multi-Agent Orchestration",
  subtitle: "Revolutionize your recruitment process with InvenioCRM's intelligent AI agents. Automate candidate sourcing, screening, and engagement while maintaining the human touch that matters.",
  ctaText: "Join our Beta Waitlist"
};

export const ctaData = {
  title: "Ready to Transform Your Hiring Process?",
  subtitle: "Join thousands of recruiters who've revolutionized their hiring with AI-native technology. Start your journey today.",
  primaryCta: "Join our Beta Waitlist",
  secondaryCta: "Schedule Demo",
  features: [
    "14-day free trial",
    "No credit card required",
    "Full AI agent access",
    "Priority support"
  ]
};

export const featuresData = [
  {
    title: "AI-Powered Candidate Sourcing",
    description: "Our intelligent agents scan thousands of profiles across multiple platforms to find the perfect candidates for your roles.",
    icon: "Search",
    color: "blue"
  },
  {
    title: "Automated Screening & Assessment",
    description: "Smart screening agents conduct initial interviews and assessments, saving you hours while maintaining quality.",
    icon: "UserCheck",
    color: "green"
  },
  {
    title: "Intelligent Email Automation",
    description: "Personalized outreach campaigns that adapt based on candidate responses and engagement patterns.",
    icon: "Mail",
    color: "purple"
  },
  {
    title: "Real-time Collaboration",
    description: "Keep your entire team aligned with shared pipelines, notes, and AI-generated insights.",
    icon: "Users",
    color: "orange"
  },
  {
    title: "Advanced Analytics Dashboard",
    description: "Track performance, identify bottlenecks, and optimize your hiring process with actionable insights.",
    icon: "BarChart3",
    color: "pink"
  },
  {
    title: "Seamless Integrations",
    description: "Connect with your existing ATS, CRM, and communication tools for a unified workflow.",
    icon: "Zap",
    color: "indigo"
  }
];

export const problemSolutionData = {
  title: "From Recruitment Challenges to AI-Powered Solutions",
  subtitle: "See how BrigAI transforms traditional hiring pain points into streamlined, intelligent processes",
  problems: [
    {
      title: "Manual Candidate Sourcing",
      description: "Hours spent searching through profiles on multiple platforms"
    },
    {
      title: "Time-Consuming Screening", 
      description: "Initial phone screenings take up valuable recruiter time"
    },
    {
      title: "Generic Outreach",
      description: "Low response rates from templated messages"
    }
  ],
  solutions: [
    {
      title: "AI Agents Automatically Source Candidates",
      description: "Intelligent agents work 24/7 to find and rank the best candidates"
    },
    {
      title: "Automated AI Screening",
      description: "Natural conversation flows handle initial screenings automatically"
    },
    {
      title: "Personalized AI-Generated Messages",
      description: "Each message is crafted specifically for the individual candidate"
    }
  ]
};

export const roiMetricsData = [
  {
    metric: "75%",
    description: "Faster Time-to-Hire",
    subtext: "Reduce your hiring timeline from weeks to days"
  },
  {
    metric: "3x",
    description: "Higher Response Rates", 
    subtext: "AI-personalized outreach gets more candidate engagement"
  },
  {
    metric: "$50K+",
    description: "Annual Savings",
    subtext: "Reduce recruiting costs through automation"
  },
  {
    metric: "95%",
    description: "Client Satisfaction",
    subtext: "Deliver better candidates faster than ever"
  }
];

export const socialProofData = {
  title: "Trusted by Leading Recruiting Teams",
  testimonials: [
    {
      quote: "InvenioCRM's AI agents have completely transformed our hiring process. We're placing candidates 3x faster.",
      author: "Sarah Chen",
      role: "VP of Talent",
      company: "TechFlow Solutions"
    },
    {
      quote: "The automated screening feature alone saves us 20 hours per week. It's like having extra team members.",
      author: "Michael Rodriguez",
      role: "Senior Recruiter",
      company: "Growth Partners"
    },
    {
      quote: "Our response rates increased by 300% after implementing their AI-powered outreach campaigns.",
      author: "Emily Watson",
      role: "Talent Acquisition Lead",
      company: "InnovateCorp"
    }
  ]
};
